import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <section className="stack">
      <h1 className="h1">Page not found</h1>
      <p className="muted">There is nothing at this address.</p>
      <Link to="/" className="link">
        Back to the start
      </Link>
    </section>
  )
}
